import {Gauge} from 'lucide-react';
import gptIcon from './chat-assets/model-logo-gpt.svg';
import deepseekIcon from './chat-assets/model-logo-deepseek.svg';

/** Copied iPad template artwork; inherit the selected reasoning tint. */
export function ModelGlyph({modelId,size=20}:{modelId?:string;size?:number}){
 const id=modelId?.trim().toLowerCase().split('/').at(-1);
 const asset=id&&(id==='gpt'||id.startsWith('gpt-')||id.startsWith('chatgpt-'))?gptIcon
  :id&&(id==='deepseek'||id.startsWith('deepseek-'))?deepseekIcon:undefined;
 return asset?<span aria-hidden="true" className="chat-ipad-model-glyph" style={{width:size,height:size,maskImage:`url("${asset}")`,WebkitMaskImage:`url("${asset}")`}}/>:<Gauge size={size} aria-hidden="true"/>;
}
